<template>
    <div>
        <v-header  :is-seft="1" @touchmove.prevent ></v-header>
        <v-goods :is-seft="1"  :is-seft-pay="0"></v-goods>
    </div>
</template>

<script>
    import header from '../components/Header';
    import goods from '../components/BuffetGoodsShow';

    export default {
        name: 'BuffetSetShow',
        inject: ['reload'],
        data() {
            return {
                seller: {},
                tableOrderInfo: {},
            }
        },
        created() {
        },
        methods: {
      
            getPath() {
                //if (this.$route.path == '/buffet') {
                //    this.getRestaurantInfo();
                //}
            }
        },
        watch: {
            '$route': 'getPath'
        },
        components: {
            'v-header': header,
            'v-goods': goods
        }
    }
</script>

<style lang="stylus" rel="stylesheet/stylus">

</style>



// WEBPACK FOOTER //
// src/components/BuffetSetShow.vue